import { useParams } from "react-router";
import { LayoutEdit } from "./LayoutEdit";

export function LayoutEditPage() {
  const { id } = useParams();

  return <LayoutEdit id={id} />;
}
